/**
 * Der Name der Liste, zu der ein Pfad zurückführt — oder null, wenn dieser
 * Pfad keine Liste ist, die eine Akte benennen könnte.
 *
 * Eine Akte leitet ihr Zurück-Label aus der mitgegebenen Herkunft ab. Seit die
 * globale Suche von jeder Seite aus dorthin springt, kann die Herkunft jeder
 * Pfad der App sein — und ein Label, das „Alle Firmen“ verspricht und zum
 * Kalender führt, ist schlimmer als ein schlichtes „Zurück“.
 *
 * Die Firmenakte hat dafür keinen Umweg über eine zweite Liste mehr: Kunden
 * sind Firmen, wer keine Herkunft mitbringt, landet bei den Firmen.
 *
 * Der Weg selbst bleibt richtig: wer vom Kalender kam, will auch dorthin
 * zurück. Falsch waren nur die Worte, also steht die Korrektur hier und nicht
 * bei dem, der navigiert.
 */
const LIST_LABELS: Record<string, string> = {
  '/firmen': 'Alle Firmen',
  '/projekte': 'Alle Projekte',
};

export function listLabel(path: string): string | null {
  return LIST_LABELS[path] ?? null;
}
